import { Injectable } from 'angular-ts-decorators';

import { Domain } from '@shared/app/scripts/services/domain';
import type { IConfig } from '@shared/app/scripts/services/config';

/**
 * # upload
 * Service in the adminApp.
 * Will be used as module to handle uploading all kinds of files in the future
 */
@Injectable('uploader')
export class Uploader {
  private spynlUrl: string;
  constructor(
    private $q: ng.IQService,
    private $http: ng.IHttpService,
    private Upload: ng.angularFileUpload.IUploadService,
    domain: Domain,
    config: IConfig,
  ) {
    'ngInject';

    this.spynlUrl = '//' + domain.sibling(config.spynlServices);
  }

  /**
   *
   * Uploads a image through the angular-upload module.
   * @param {string} base64
   * Base64 encoded image string
   * @param {File} file
   * Javascript File object
   * @returns {promise} resolves with object containing the response of the http request.
   * Reject with an error message.`
   */
  uploadImage(base64: string, file: File): ng.IPromise<any> {
    if (!file) {
      //TODO translation
      return this.$q.reject('No file added');
    }

    const base64WithoutMeta = base64.split(',')[1];

    return (
      this.Upload.http({
        url: this.spynlUrl + '/images/add',
        method: 'POST',
        headers: {
          'Content-Type': file.type,
        },
        data: {
          file: base64WithoutMeta,
          filename: file.name,
        },
      })
        //TODO use sw-notification-center
        .then((request: any) => {
          request.data.base64 = base64;
          return request.data;
        })
    );
  }

  /**
   *
   * Uploads a image through the angular-upload module.
   * @param {object} file
   * Javascript File object
   * @param {string} tenantId
   * Optional tenant id parameter
   * @returns {promise} resolves with object containing the response of the http request.
   * Reject with an error message.`
   */
  uploadLogo(file: File, tenantId?: string): ng.IPromise<any> {
    let url;
    if (!file) {
      //TODO translation
      return this.$q.reject('No file added');
    }
    if (tenantId) {
      url = this.spynlUrl + '/tenants/' + tenantId + '/logos/add';
    } else {
      url = this.spynlUrl + '/logos/add';
    }

    return this.Upload.base64DataUrl(file).then((base64: string) => {
      //Remove the metadata example = "ata:image/png;base64,iVBORw0KGgoAA" becomes "iVBORw0KGgoAA"
      const base64WithoutMeta = base64.split(',')[1];

      return this.Upload.http({
        url: url,
        method: 'POST',
        headers: {
          'Content-Type': file.type,
        },
        data: {
          file: base64WithoutMeta,
          filename: file.name,
        },
      }) //TODO use sw-notification-center
        .then((request: any) => {
          request.data.base64 = base64;
          return request.data;
        });
    });
  }

  /**
   *
   * Remove the logo image.
   * @param {string} tenantId
   * Optional tenant id parameter
   * @returns {promise}
   * $http promise
   */
  deleteLogo(tenantId?: string): ng.IPromise<any> {
    let url;

    if (tenantId) {
      url = this.spynlUrl + '/tenants/' + tenantId + '/logos/remove';
    } else {
      url = this.spynlUrl + '/logos/remove';
    }

    return this.$http.post(url, null);
  }
}
